export default __webpack_public_path__ + "static/7-6b6dd80bcbecd5713b92fe1f071c56e4.png";